<div class="live-syslog-container">
  <div class="controls">
    <div class="form-group" style="margin-bottom: 0; margin-right: 10px;">
      <label class="sr-only" for="serialNumber">Serial Number</label>
      <input class="form-control" id="serialNumber" placeholder="Enter Serial Number" style="width: 300px;"
        type="text" [(ngModel)]="serialNumber">
    </div>
    <div class="form-group" style="margin-bottom: 0; margin-right: 10px;">
      <label for="lineCount">Lines</label>
      <select class="form-control" id="lineCount" style="cursor: pointer" [(ngModel)]="lineCount">
        <option [ngValue]="100">100</option>
        <option [ngValue]="500">500</option>
        <option [ngValue]="1000">1000</option>
        <option [ngValue]="5000">5000</option>
        <option [ngValue]="10000">10000</option>
      </select>
    </div>
    <button class="btn btn-primary" id="load-logs-btn" [disabled]="!serialNumber || loading" (click)="loadLogs()">
      Load Logs
    </button>
    <button class="btn btn-light" style="align-self: flex-end" (click)="openHelp()">
      Tool Explanation
    </button>
    <div class="form-check" style="margin-left: 10px; align-self: flex-end;">
      <input class="form-check-input" id="wordWrap" type="checkbox" [(ngModel)]="wordWrap" (ngModelChange)="onWordWrapChange()">
      <label class="form-check-label" for="wordWrap">
        Word Wrap
      </label>
    </div>
  </div>

  <div *ngIf="logs.length > 0; else noLogs" #viewer class="viewer" [class.word-wrap]="wordWrap">
    <div *ngFor="let log of logs" class="log-line">
      <span class="timestamp">{{ log.timestamp | date:'medium' }}</span>
      <span class="process">{{ log.process?.name }}</span>:
      <span class="message">{{ log.message }}</span>
    </div>
  </div>

  <ng-template #noLogs>
    <div *ngIf="!loading" class="no-logs">No logs to display. Enter a serial number and click Load Logs.</div>
    <div *ngIf="loading" class="no-logs">Loading...</div>
  </ng-template>

  <div class="actions">
    <button class="btn btn-secondary" [disabled]="!serialNumber || cooldown > 0 || requesting"
      (click)="requestNewLog()">
      <span *ngIf="requesting" aria-hidden="true" class="spinner-border spinner-border-sm" role="status"></span>
      <span *ngIf="!requesting">{{ cooldown > 0 ? 'Wait ' + cooldown + 's' : 'Request New Log' }}</span>
    </button>
  </div>
</div>
